import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=3a0bbdd7&scoped=true&"
import script from "./DataForm.vue?vue&type=script&lang=ts&"
export * from "./DataForm.vue?vue&type=script&lang=ts&"
import style0 from "./DataForm.vue?vue&type=style&index=0&id=3a0bbdd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0bbdd7",
  null
  
)

export default component.exports